export default __webpack_public_path__ + "static/media/chill-start-music.dd8452a3.mp3";